function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e30512;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M42.52,21.26c0,11.74-9.52,21.26-21.26,21.26S0,33,0,21.26,9.52,0,21.26,0s21.26,9.52,21.26,21.26"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M26.35,28.89l-10.41-4.76c-.39.51-.89.95-1.46,1.26l5.61,17.09c.39.02.78.04,1.18.04,2.76,0,5.39-.53,7.81-1.49l-2.72-12.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M25.83,26.59l-2.39-10.64-6.76,3.85c.15.46.23.95.23,1.45,0,.41-.06.81-.16,1.19l9.08,4.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M11.57,16.56c.2-.02.4-.04.6-.04,1.43,0,2.72.64,3.59,1.65l7.25-4.13L19.87.04c-4.6.3-8.8,2.05-12.14,4.81l3.84,11.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M7.69,22.77c-.16-.48-.25-.98-.25-1.51,0-.33.03-.65.1-.96L.42,17.05c-.27,1.36-.42,2.77-.42,4.21,0,1.9.25,3.74.72,5.49l6.97-3.97Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M9.8,17.16h0l-3.59-10.92C3.75,8.7,1.9,11.77.88,15.19l7.39,3.38c.4-.58.92-1.06,1.53-1.41"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M28.49,29.87l2.33,10.38c2.85-1.44,5.33-3.5,7.27-6l-9.6-4.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M12.68,25.96c-.17.02-.34.03-.51.03-1.41,0-2.68-.62-3.54-1.6l-7.33,4.18c2.63,7.17,9,12.53,16.75,13.7l-5.35-16.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M42.52,21.25c0-5.1-1.8-9.78-4.79-13.45l-12.58,7.17,2.83,12.59,11.21,5.12c2.11-3.3,3.34-7.22,3.34-11.43"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M12.17,24.12c1.58,0,2.86-1.28,2.86-2.86s-1.28-2.86-2.86-2.86-2.86,1.28-2.86,2.86,1.28,2.86,2.86,2.86"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M24.72,13.06l11.73-6.68C32.7,2.55,27.53.14,21.79,0l2.93,13.06Z"
}))));

var SvgOmni = function SvgOmni(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOmni, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Omni.054a73e9.svg";
export { ForwardRef as ReactComponent };